import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import Panel from 'react-bootstrap/lib/Panel'
import Star from 'react-icons/lib/md/star'

import Loading from 'components/Loading'

import { fetchCurrentSemester, setDefaultSemester, setActive, setOpen } from './actions'

class Semester extends Component {

  constructor(props) {
    super(props)

    this.state = {
      data: null,
    }
  }

  componentWillMount() {
    this.props.dispatch(fetchCurrentSemester())
      .then((res) => {
        if (!res.error) {
          this._setState(fromJS(res.payload))
        }
      })
  }

  _setState(data) {
    this.setState({ data })
  }

  _setDefault = () => {
    this.props.dispatch(setDefaultSemester())
      .then((res) => {
        if (!res.error) {
          this._setState(fromJS(res.payload))
        }
      })
  }

  _setActive = () => {
    this.props.dispatch(setActive(!this.state.data.get('is_active')))
      .then((res) => {
        if (!res.error) {
          this._setState(fromJS(res.payload))
        }
      })
  }

  _setOpen = () => {
    this.props.dispatch(setOpen(!this.state.data.get('is_open')))
      .then((res) => {
        if (!res.error) {
          this._setState(fromJS(res.payload))
        }
      })
  }

  render() {
    const { data } = this.state

    if (!data) {
      return <Loading />
    }

    const isDefault = data.get('is_default') ? 'Yes' : 'No'
    const isActive = data.get('is_active') ? 'Yes' : 'No'
    const isOpen = data.get('is_open') ? 'Yes' : 'No'

    return (
      <Panel header="Current Semester Settings">
        <div style={{margin: '30px'}}>
          <table className="table-settings">
            <tbody>
              <tr>
                <td>Current Semester:</td>
                <td className="setting-value">
                  <strong>
                    {data.get('sy')} - {data.get('sem')}
                    {data.get('is_default') && <Star className="text-yellow" />}
                  </strong>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Campus:</td>
                <td className="setting-value">{data.get('campus_name')}</td>
                <td></td>
              </tr>
              <tr>
                <td>Campus Director:</td>
                <td className="setting-value">{data.getIn(['meta', 'directory'])}</td>
                <td></td>
              </tr>
              <tr>
                <td>Is Default Semester</td>
                <td className="setting-value">{isDefault}</td>
                <td>
                  {!data.get('is_default') && <button onClick={this._setDefault} type="button" className="btn-table">Set as default semester</button>}
                </td>
              </tr>
              <tr>
                <td>Is Active</td>
                <td className="setting-value">{isActive}</td>
                <td><button onClick={this._setActive} type="button" className="btn-table">Toggle yes/no</button></td>
              </tr>
              <tr>
                <td>Is Open</td>
                <td className="setting-value">{isOpen}</td>
                <td><button onClick={this._setOpen} type="button" className="btn-table">Toggle yes/no</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }
}

Semester.propTypes = {
  dispatch: PropTypes.func,
}

export default connect()(Semester)



// WEBPACK FOOTER //
// ./src/containers/Settings/Semester/index.js